import { render, staticRenderFns } from "./LifeDailyCardType.vue?vue&type=template&id=6aae2b0e&scoped=true&"
import script from "./LifeDailyCardType.vue?vue&type=script&lang=js&"
export * from "./LifeDailyCardType.vue?vue&type=script&lang=js&"
import style0 from "./LifeDailyCardType.vue?vue&type=style&index=0&id=6aae2b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae2b0e",
  null
  
)

export default component.exports